import {
  Badge,
  Avatar,
  AvatarImage,
  AvatarFallback,
  Icon,
} from "@elaniintc/goes-design-system";
import type { TagType } from "@/types/entities/tags";
import dayjs from "dayjs";

interface TagDetailProps {
  tag: TagType;
}

export const TagDetail = ({ tag }: TagDetailProps) => {
  const imageUrl =
    tag.files && tag.files.length > 0
      ? tag.files[tag.files.length - 1].url
      : null;

  return (
    <div className="self-stretch self-stretch p-8 inline-flex flex-col justify-start items-start gap-8 overflow-hidden">
      {/* Tag Header */}
      <div className="self-stretch flex flex-col justify-start items-start gap-6">
        <div className="flex items-center gap-4">
          <Avatar size="lg" shape="square">
            <AvatarImage src={imageUrl || ""} alt={tag.name} />
            <AvatarFallback color="neutral" shape="square" type="icon">
              <Icon type="fas" name="tag" />
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col gap-2">
            <h1 className="text-2xl font-semibold text-body-loud">
              {tag.name}
            </h1>
            <div className="flex items-center gap-2">
              <Badge
                variant={tag.active ? "success" : "neutral"}
                shape="pill"
                size="sm"
              >
                {tag.active ? "Activa" : "Inactiva"}
              </Badge>
              <span className="text-sm text-body-quiet">
                {tag.processes_count} proceso
                {tag.processes_count !== 1 ? "s" : ""} asociado
                {tag.processes_count !== 1 ? "s" : ""}
              </span>
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="self-stretch flex flex-col gap-2">
          <h3 className="text-lg font-semibold text-body-loud">Descripción</h3>
          <p className="text-base text-body leading-relaxed">
            {tag.description || "Sin descripción"}
          </p>
        </div>

        {/* Metadata */}
        <div className="self-stretch grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-semibold text-body-loud">
              Fecha de creación
            </h3>
            <p className="text-base text-body">
              {dayjs(tag.created_at).format("DD [de] MMMM, YYYY | HH:mm")}
            </p>
          </div>
          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-semibold text-body-loud">
              Última actualización
            </h3>
            <p className="text-base text-body">
              {dayjs(tag.updated_at).format("DD [de] MMMM, YYYY | HH:mm")}
            </p>
          </div>
        </div>

        {/* Image if exists */}
        {imageUrl && (
          <div className="self-stretch flex flex-col gap-2">
            <h3 className="text-lg font-semibold text-body-loud">Imagen</h3>
            <div className="w-32 h-32 rounded-lg overflow-hidden border border-neutral-quiet">
              <img
                src={imageUrl}
                alt={tag.name}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
